import { Injectable, inject } from '@angular/core'
import { AccountAPIService, OrganizationAPIService, UserAPIService } from '@modules/bv-api'
import { AuthCookieService } from '@ziptility/modules'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { BasemapActions, MapsActions } from '@store/actions'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import * as OrganizationActions from './actions'
import { AuthService } from '@ziptility/services'

@Injectable()
export class OrganizationEffects {
  readonly actions$ = inject(Actions)
  readonly organizationAPIService = inject(OrganizationAPIService)
  readonly accountAPIService = inject(AccountAPIService)
  readonly userAPIService = inject(UserAPIService)
  readonly cookieService = inject(AuthCookieService)
  readonly authService = inject(AuthService)

  OrganizationsRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganizationActions.fetchOrganizations),
      switchMap(() => {
        return this.organizationAPIService.getMyOrganizations().pipe(
          map((orgs) => OrganizationActions.fetchOrganizationsSuccess({ orgs })),
          catchError((error) => of(OrganizationActions.fetchOrganizationsError({ error }))),
        )
      }),
    ),
  )

  OrganizationRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganizationActions.fetchOrganization),
      switchMap(() =>
        this.organizationAPIService.get().pipe(
          switchMap((org) => [
            OrganizationActions.fetchUsers(),
            OrganizationActions.fetchOrganizationSuccess({ org }),
            MapsActions.fetchMaps(),
            BasemapActions.loadBasemaps(),
          ]),
          catchError((error) => of(OrganizationActions.fetchOrganizationError({ error }))),
        ),
      ),
    ),
  )

  LoadUsersRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganizationActions.fetchUsers),
      switchMap(() => {
        return this.userAPIService.listInfo().pipe(
          map((users) => OrganizationActions.fetchUsersSuccess({ users })),
          catchError((error) => of(OrganizationActions.fetchUsersError({ error }))),
        )
      }),
    ),
  )
}
